import React, { FC } from 'react';
import Icon from '@ant-design/icons';

export const FileFilled: FC = props => <Icon component={FileFilledSVG} {...props} />;

const FileFilledSVG = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18 21.9999H6C4.89543 21.9999 4 21.1045 4 19.9999V3.99989C4 2.89533 4.89543 1.99989 6 1.99989H13C13.009 1.99873 13.018 1.99873 13.027 1.99989H13.033C13.0424 2.00285 13.0522 2.00486 13.062 2.00589C13.1502 2.01155 13.2373 2.02869 13.321 2.05689H13.363C13.3815 2.06982 13.3988 2.0842 13.415 2.09989C13.5239 2.14832 13.6232 2.21608 13.708 2.29989L19.708 8.29989C19.7918 8.38468 19.8596 8.48395 19.908 8.59289C19.917 8.61489 19.924 8.63589 19.931 8.65889L19.941 8.68689C19.9689 8.77028 19.9854 8.85708 19.99 8.94489C19.9909 8.95486 19.9932 8.96463 19.997 8.97389V8.97989C19.9986 8.98645 19.9996 8.99315 20 8.99989V19.9999C20 20.5303 19.7893 21.039 19.4142 21.4141C19.0391 21.7892 18.5304 21.9999 18 21.9999ZM13 3.99989V8.99989H18L13 3.99989Z'
      fill='#007BFB'
    />
  </svg>
);
